<div class="row container-banner-secretaria-trabajo">
	<div class="col-12 col-md-6 d-none d-sm-block">
		<p>Manpower es una empresa avalada por la Secretaría del <br>Trabajo y Previsión Social como prestadora de Servicios <br>Especializados u Obras Especializadas en cumplimiento <br>a la nueva forma de subcontratación de personal.</p>
	</div>

	<div class="col-12 col-md-6">
		<img src="assets/img/servicios-especializados/REPSE.png" class="img-fluid float-start sec-tra">
		<img src="assets/img/servicios-especializados/STPS.png" class="img-fluid float-end sec-tra">
	</div>
</div>

<div class="d-block d-sm-none">
	<p>Manpower es una empresa avalada por la Secretaría del <br>Trabajo y Previsión Social como prestadora de Servicios <br>Especializados u Obras Especializadas en cumplimiento a la <br>nueva forma de subcontratación de personal.</p>
</div>